import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import { AuthContext } from '../../context/AuthContext';
import { TipoContaPagarContext } from '../../context/TipoContaPagarContext';
import { TipoContaPagarType, CreateTipoContaPagarType, UpdateTipoContaPagarType } from '../../context/hooks/useTipoContaPagar';
import useUser from '../../context/hooks/useUser';

const TipoContaPagar = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listTipoContaPagar, tipoContaPagarPageCount, getAllTipoContaPagarPaged, createTipoContaPagar, updateTipoContaPagar, deleteTipoContaPagar } = useContext(TipoContaPagarContext);
    const { getPermissionsByUser, userPermissions } = useUser();
    const [newTipoContaPagar, setNewTipoContaPagar] = useState<CreateTipoContaPagarType>({
        name: '',
        empresaId: objUserTk.EmpresaId,
    });
    const [editingTipoContaPagar, setEditingTipoContaPagar] = useState<UpdateTipoContaPagarType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);

    const [filters, setFilters] = useState({
        name: '',
    });
    const [dataSearch, setDataSearch] = useState({ name: '' });

    useEffect(() => {
        setLoading(true);
        getAllTipoContaPagarPaged(1, pageSize, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar categorias:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllTipoContaPagarPaged(value, pageSize, objUserTk.EmpresaId);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllTipoContaPagarPaged(1, pageSize, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({ name: '' });
        setLoading(true);
        getAllTipoContaPagarPaged(1, pageSize, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setNewTipoContaPagar(prevTipoContaPagar => ({
            ...prevTipoContaPagar,
            [name]: value === '' ? null : value
        }));
    };

    const handleCreateTipoContaPagar = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const payload = {
            ...newTipoContaPagar,
            name: newTipoContaPagar.name,
            empresaId: Number(newTipoContaPagar.empresaId)
        };

        createTipoContaPagar(payload)
            .then(createdTipoContaPagar => {
                if (createdTipoContaPagar) {
                    setCreateModalOpen(false);
                    setNewTipoContaPagar({
                        name: '',
                        empresaId: objUserTk.EmpresaId,
                    });
                    getAllTipoContaPagarPaged(1, pageSize, objUserTk.EmpresaId);
                } else {
                    console.error("Erro ao criar categoria do finaneiro.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar categoria do financeiro:", error);
            });
    };

    const handleEditTipoContaPagar = (tipoContaPagar: TipoContaPagarType) => {
        setEditingTipoContaPagar(tipoContaPagar);
        setEditModalOpen(true);
    };

    const handleEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingTipoContaPagar) {
            const updatedData = {
                ...editingTipoContaPagar,
            };
            updateTipoContaPagar(updatedData)
                .then(updatedTipoContaPagar => {
                    if (updatedTipoContaPagar) {
                        setEditModalOpen(false);
                        getAllTipoContaPagarPaged(1, pageSize, objUserTk.EmpresaId);
                        setEditingTipoContaPagar(null);
                    } else {
                        console.error("Erro ao atualizar categoria.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar categoria:", error);
                });
        }
    };

    const handleDeleteTipoContaPagar = (tipoContaPagarId: number) => {
        if (window.confirm("Tem certeza que deseja excluir esta categoria?")) {
            deleteTipoContaPagar(tipoContaPagarId)
                .then(deletedTipoContaPagar => {
                    if (deletedTipoContaPagar) {
                        getAllTipoContaPagarPaged(1, pageSize, objUserTk.EmpresaId);
                    } else {
                        console.error("Erro ao excluir categoria.");
                    }
                    getAllTipoContaPagarPaged(1, pageSize, objUserTk.EmpresaId);
                })
                .catch(error => {
                    console.error("Erro ao excluir categoria:", error);
                });
        }
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Categoria Financeira"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    <Col xs="12" md="9" lg="9" className="mb-2">
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Buscar por nome da categoria"
                            value={dataSearch.name}
                            onChange={handleFilterChange}
                        />
                    </Col>
                    <Col xs="12" md="3" lg="3" className="d-flex justify-content-start justify-content-md-end mb-2">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            type="button"
                            size="m"
                            onClick={handleSearch}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            type="button"
                            size="m"
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>
                    {userPermissions.includes(1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar categoria
                            </Button>
                        </Col>
                    )}
                </Row>

                {userPermissions.includes(2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Nome</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listTipoContaPagar.map((tipoContaPagar: TipoContaPagarType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{tipoContaPagar.id}</td>
                                                <td>{tipoContaPagar.name}</td>
                                                <td>
                                                    {userPermissions.includes(3) && (
                                                        <Button onClick={() => { handleEditTipoContaPagar(tipoContaPagar) }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {userPermissions.includes(4) && (
                                                        <Button onClick={() => handleDeleteTipoContaPagar(tipoContaPagar.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            {/* <div className="d-flex justify-content-end mt-3">
                                {tipoContaPagarPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={tipoContaPagarPageCount}
                                        />
                                    </div>
                                )}
                                {listTipoContaPagar.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div> */}
                            <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                                <div className="mb-2 mb-md-0">
                                    <Label className="form-control-label mr-2">Registros por página:</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        bsSize="sm"
                                        style={{ width: "100px", display: "inline-block" }}
                                        value={pageSize}
                                        onChange={(e) => {
                                            const newSize = parseInt(e.target.value);
                                            setPageSize(newSize);
                                            getAllTipoContaPagarPaged(1, newSize, objUserTk.EmpresaId);
                                        }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={15}>15</option>
                                        <option value={20}>20</option>
                                        <option value={25}>25</option>
                                    </Input>
                                </div>

                                {tipoContaPagarPageCount && (
                                    <div className="mt-2 mt-md-0">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={tipoContaPagarPageCount}
                                        />
                                    </div>
                                )}

                                {listTipoContaPagar.length === 0 && (
                                    <div className="w-100 mt-3" style={{ color: "red" }}>
                                        NÃO FOI ENCONTRADO NENHUM REGISTRO
                                    </div>
                                )}
                            </div>

                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as categorias do financeiro.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container >

            <Modal isOpen={createModalOpen} toggle={() => setCreateModalOpen(!createModalOpen)} backdrop="static" size="lg">
                <ModalHeader toggle={() => setCreateModalOpen(!createModalOpen)}>Adicionar nova categoria</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleCreateTipoContaPagar}>
                        <Row>
                            <Col md='12'>
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="input-name">
                                        Nome da categoria
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={newTipoContaPagar.name}
                                        onChange={handleCreateInputChange}
                                        required
                                        placeholder="Ex: Despesas com marketing, Despesas com vendas, etc."
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-3">
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Criar categoria</Button>
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => setCreateModalOpen(!createModalOpen)} size="m" className="ml-2">Cancelar</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(!editModalOpen)} backdrop="static" className="custom-modal-xl">
                <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>Editar informações da categoria</ModalHeader>
                <ModalBody>
                    {editingTipoContaPagar && (
                        <>
                            <Form onSubmit={handleEditSubmit}>
                                <Row>
                                    <Col md='12'>
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-name">Nome da categoria</Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="name"
                                                id="name"
                                                value={editingTipoContaPagar.name}
                                                onChange={e => setEditingTipoContaPagar({ ...editingTipoContaPagar, name: e.target.value })}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="d-flex justify-content-end">
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Salvar alterações</Button>
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => setEditModalOpen(!editModalOpen)} size="m">Cancelar</Button>
                                </div>
                            </Form>
                        </>
                    )}
                </ModalBody>
            </Modal>
        </>
    );
};

export default TipoContaPagar;